import { motion, useReducedMotion } from 'motion/react';
import { pageMotion } from './motion';

export default function Page({ children, title, description, actions, className = '' }) {
  const reduceMotion = useReducedMotion();
  const motionProps = reduceMotion ? {} : pageMotion;

  return (
    <motion.div className={['aui-page', className].filter(Boolean).join(' ')} {...motionProps}>
      <div className="aui-page-head">
        <div>
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </div>
        {actions && <div className="aui-actions">{actions}</div>}
      </div>
      {children}
    </motion.div>
  );
}
